import { motion } from "framer-motion";
import { GOLD, STAGES } from "./data";

export function Pipeline({ stage }) {
  return (
    <div className="relative grid grid-cols-6 gap-2" data-testid="engine-pipeline">
      <div className="absolute left-[8%] right-[8%] top-6 h-px bg-white/10" />
      <motion.div className="absolute left-[8%] top-6 h-px" style={{ background: GOLD, boxShadow: `0 0 12px ${GOLD}` }}
        animate={{ width: `${(stage / (STAGES.length - 1)) * 84}%` }} transition={{ duration: 0.6, ease: "easeInOut" }} />
      {STAGES.map((s, i) => {
        const on = i === stage, done = i < stage;
        return (
          <div key={s.key} className="relative flex flex-col items-center text-center" data-testid={`engine-stage-${s.key}`}>
            <motion.div animate={{ scale: on ? 1.18 : 1 }} transition={{ type: "spring", stiffness: 260, damping: 18 }}
              className="h-12 w-12 rounded-full grid place-items-center text-xs font-black border"
              style={{ background: on ? GOLD : done ? "#1c1606" : "#0a0a0a", color: on ? "#000" : done ? GOLD : "rgba(255,255,255,0.4)",
                       borderColor: on || done ? GOLD : "rgba(255,255,255,0.15)", boxShadow: on ? `0 0 28px ${GOLD}99` : "none" }}>
              {String(i + 1).padStart(2, "0")}
            </motion.div>
            <div className={`mt-3 text-[11px] font-bold tracking-[0.25em] ${on ? "text-[#F5C451]" : "text-white/50"}`}>{s.label}</div>
            <div className="mt-1 text-[10px] text-white/35 leading-snug hidden md:block">{s.sub}</div>
          </div>
        );
      })}
    </div>
  );
}
